import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkull1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "skull-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,10.5a9.75,9.75,0,1,0-16.5,7.025V21a2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0V17.525A9.714,9.714,0,0,0,21.75,10.5Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 7.5,
			cy: 10.5,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 16.5,
			cy: 10.5,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 15,
			x2: 12,
			y2: 17.25
		})
	]
});
export default SvgSkull1;
